/// <amd-module name="Artifacts/Package/components/OverviewTab" />
import { DefaultLoader } from "Artifacts/Root/components/DefaultLoader";
import { ComponentState } from "Artifacts/Root/Constants";
import { IProtocol } from "Artifacts/Root/protocols/types";
import { IFeed, IPackage, IPackageVersion } from "Artifacts/Root/types";
import * as React from "react";

export interface IOverviewTabProps {
  feed: IFeed;
  pkg: IPackage;
  protocol: IProtocol;
  packageVersion: IPackageVersion;
  componentState: ComponentState;
}

const OverviewTab: React.FC<IOverviewTabProps> = ({
  feed,
  packageVersion,
  componentState,
  pkg,
  protocol,
}) => {
  const ProtocolOverviewComponent = protocol.getOverviewComponent();
  const ProtocolAttributesComponent = protocol.getOverviewAttributesComponent();

  return (
    <div className="package-overview-tab page-content page-content-top">
      <DefaultLoader state={componentState}>
        <ProtocolOverviewComponent feed={feed} pkg={pkg} version={packageVersion} />
        <ProtocolAttributesComponent feed={feed} pkg={pkg} version={packageVersion} />
      </DefaultLoader>
    </div>
  );
};

export { OverviewTab };
